import React from 'react'
import LeftImageContainer from 'Common/LeftImageContainer';
import Grid from '@mui/material/Grid';
import styles from './index.module.scss'
import ForgetPasswordImg from 'Assets/Images/forgotpassword.png'
import ForgetPasswordForm from 'Components/ForgetPassword';

const ForgetPassword = () => {
    return (
        <Grid container>
            <Grid item xs={12} md={7}>
                <LeftImageContainer heading='FORGOT PASSWORD' Image={ForgetPasswordImg} />
            </Grid>

            <Grid item xs={12} md={5} className={styles.container}>
                <ForgetPasswordForm />
            </Grid>
        </Grid >
    );
}

export default ForgetPassword;